// extracted by mini-css-extract-plugin
export default {"header":"gn8TWx3ayX7RXTDjXMJ9"};